import { render } from "./RemisePhysiqueModal.vue?vue&type=template&id=2623c9a0&scoped=true"
import script from "./RemisePhysiqueModal.vue?vue&type=script&lang=js"
export * from "./RemisePhysiqueModal.vue?vue&type=script&lang=js"

import "./RemisePhysiqueModal.vue?vue&type=style&index=0&id=2623c9a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2623c9a0"]])

export default __exports__